import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { settings } from 'environments/environment';

/**
 * Guard sprawdzający czy KSeF jest włączony w ustawieniach środowiska.
 * Jeśli KSeF jest wyłączony, route nie zostanie dopasowany (canMatch zwraca false).
 */
export const KsefEnabledGuard: CanMatchFn = (route, segments) => {
  const router = inject(Router);

  if (!settings.ksefEnabled) {
    // Przekieruj na dokumenty jeśli KSeF jest wyłączony
    router.navigate(['/konto/dokumenty']);
    return false;
  }

  return true;
};

